import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { BrandSuggestionResponse } from '../brand-fetch/brand-fetch.service';
import { BusinessRegistrationTypeEnum, CreateBusinessAccountDto, CreateUserDto, UserRolesEnum } from '../../../../common/general-types/users.dto';
import { FirebaseService } from '../../../../common/firebase/firebase.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { CurrentUserService } from '../../../../common/current-user/current-user.service';

@Injectable({
  providedIn: 'root'
})
export class OnboardingBrandService {


  brandInformation: BrandSuggestionResponse | undefined;
  goalInformation: { id: number, name: string, description: string, color: string } | undefined;
  userProfileInformation: { firstName: string, lastName: string, email: string, password: string } | undefined;

  private http = inject(HttpClient);
  private firebaseService = inject(FirebaseService);
  private currentUserService = inject(CurrentUserService);

  // hubspot tracking code. should be the same cross domain and auto populated by hubspot script
  hubspotUserTokenBrand: string | undefined;

  constructor() { }

  async registerBrandUser() {
    console.log('----> registerBrandUser()')

    const personalInfoReq: CreateUserDto = {
      firebaseUid: '',
      email: this.userProfileInformation?.email ?? 'no email...',
      firstName: this.userProfileInformation?.firstName ?? 'First',
      lastName: this.userProfileInformation?.lastName ?? 'Last',
      role: UserRolesEnum["Brand Admin"],
      jobPosition: 'unknown', // To-Do: Add job position
      photoURL: '',
      isActive: true,
      hubspotUserToken: this.hubspotUserTokenBrand ?? 'not-sure-my-bru-brand',
    };

    if (this.userProfileInformation && this.userProfileInformation.email && this.userProfileInformation.password) {
      try {
        const newUserResult = await firstValueFrom(this.firebaseService.signUp(this.userProfileInformation.email, this.userProfileInformation.password))
        if (newUserResult.user) {
          /** Create Shout User */
          personalInfoReq.firebaseUid = newUserResult.user.uid;
          let user_register_url = `${environment.shout_api.url}/business-accounts/onboarding-brand`
          const createUserResult = await firstValueFrom(
            this.http.post(user_register_url, personalInfoReq, {
              headers: {
                'Content-Type': 'application/json',
              }
            })
          )
          if (createUserResult) {
            console.log('User created successfully: ', createUserResult);
            this.currentUserService.setShoutUser(createUserResult);

            /** Create Shout Brand */

            const businessInfoReq: CreateBusinessAccountDto = {
              companyName: this.brandInformation?.name ?? 'No name...',
              website: this.brandInformation?.domain ?? 'No website...',
              instagram: '',
              tiktok: '',
              about: '',
              coverPhoto: this.brandInformation?.icon ?? 'No icon...',
              companyLogo: this.brandInformation?.icon ?? 'No icon...',
              creatorId: personalInfoReq.firebaseUid,
              isActive: true,
              currencyCode: 'GBP', // To-Do: Add currency code
              isPayg: false,
              industries: [{
                emoji: this.brandInformation?.icon ?? 'No icon...',
                id: this.brandInformation?.brandId ?? 'No id...',
                name: this.brandInformation?.name ?? 'No name...',
                slug: this.brandInformation?.domain ?? 'No domain...',
                score: this.brandInformation?.qualityScore ?? 0
              }],
              vatNumber: ''
            };

            let create_brand_url = `${environment.shout_api.url}/business-accounts/associate-brand-to-user`
            const createBrandResult = await firstValueFrom(
              this.http.post(create_brand_url, businessInfoReq, {
                headers: {
                  'Content-Type': 'application/json',
                }
              })
            )
            console.log('✅👉 Create Brand Result 1: ', createBrandResult);
            return createBrandResult;
          } else {
            console.error('Failed to create user');
            return null;
          }
        } else {
          console.error('Failed to create user');
          return false;
        }
      } catch (signUpError) {
        console.error('Failed to create user: ', signUpError);
        throw signUpError;
      }
    }
    return false;
  }
}
